import { driver } from 'driver.js';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';

export const useParrillaSegmentsTour = () => {
  const driverRef = useRef<any>(null);
  const { t } = useTranslation();

  const initDriver = () => {
    driverRef.current = driver({
      showProgress: true,
      allowClose: true,
      doneBtnText: t('Finalizar'),
      nextBtnText: t('Siguiente'),
      prevBtnText: t('Anterior'),
      steps: [
        {
          element: '#parrilla-segments-page',
          popover: {
            title: 'Franjas del programa!',
            description: 'Aqui veremos TODAS las franjas asociadas a un programa',
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#parrilla-segments-info',
          popover: {
            title: 'Información del programa',
            description:
              'En esta sección puedes ver la información del programa asociado a las franjas',
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#shorcut',
          popover: {
            title: 'Atajos de teclado',
            description: 'Dandole click a este icono puedes ver los atajos de teclado disponibles',
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#parrilla-segments-filter',
          popover: {
            title: 'Filtros de franjas',
            description: 'Aqui tienes todos los filtros disponibles para buscar las franjas',
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#parrilla-segments-search',
          popover: {
            title: 'Búsqueda de franjas',
            description: 'Puedes buscar franjas por nombre, fecha',
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#segments-fast-filters',
          popover: {
            title: 'Filtros rápidos',
            description:
              'Estos son todos los filtros rápidos que puedes usar para buscar las franjas',
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#segments-column-filters',
          popover: {
            title: 'Filtros de columnas',
            description: 'Con estos botones puedes controlar la visibilidad de las columnas',
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#parrilla-segments-detail',
          popover: {
            title: 'Detalle de la franja',
            description: 'Aqui estará el detalle de la franja seleccionada',
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#parrilla-segments-toolkit-detail',
          popover: {
            title: 'Detalle del toolkit',
            description: 'En esta sección podrás ver el detalle del toolkit seleccionado',
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#segments-toolkit',
          popover: {
            title: 'Toolkits disponibles',
            description:
              'En esta columna podras ver las toolkits disponibles para la franja seleccionada',
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#help',
          popover: {
            title: 'Ayuda',
            description:
              'Para iniciar el tour de ayuda, haz click en este icono y sigue las instrucciones',
            side: 'bottom',
            align: 'start',
          },
        },
      ],
    });
  };

  const startTour = () => {
    if (!driverRef.current) {
      initDriver();
    }
    driverRef.current.drive();
  };

  return { startTour };
};
